var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "overflow-auto" }, [
          Object.keys(_vm.deliveryData).length
            ? _c("table", { staticClass: "table table-sm table-hover" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th"),
                      _vm._v(" "),
                      _vm._l(_vm.$AllProjects, function (project) {
                        return project.is_active
                          ? _c("th", [
                              _c("p", [_vm._v(_vm._s(project.name))]),
                              _vm._v(" "),
                              _c("p", [_vm._v("макс/норм/льгот")]),
                              _vm._v(" "),
                              _c("p", [_vm._v("сумма чека/доставка")]),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.$AllCities, function (city) {
                    return _c(
                      "tr",
                      [
                        _c("td", [_vm._v(_vm._s(city.name))]),
                        _vm._v(" "),
                        _vm._l(_vm.$AllProjects, function (project) {
                          return project.is_active
                            ? _c("td", [
                                _c("div", { staticClass: "flex" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.deliveryData[project.id][city.id]
                                            .max_price,
                                        expression:
                                          "deliveryData[project.id][city.id].max_price",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.deliveryData[project.id][city.id]
                                          .max_price,
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.deliveryData[project.id][
                                          city.id
                                        ].updated = true
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.deliveryData[project.id][city.id],
                                          "max_price",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.deliveryData[project.id][city.id]
                                            .price,
                                        expression:
                                          "deliveryData[project.id][city.id].price",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.deliveryData[project.id][city.id]
                                          .price,
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.deliveryData[project.id][
                                          city.id
                                        ].updated = true
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.deliveryData[project.id][city.id],
                                          "price",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.deliveryData[project.id][city.id]
                                            .exemption,
                                        expression:
                                          "deliveryData[project.id][city.id].exemption",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value:
                                        _vm.deliveryData[project.id][city.id]
                                          .exemption,
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.deliveryData[project.id][
                                          city.id
                                        ].updated = true
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.deliveryData[project.id][city.id],
                                          "exemption",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.deliveryData[project.id][city.id]
                                            .bill,
                                        expression:
                                          "deliveryData[project.id][city.id].bill",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      p1laceholder: "Чек",
                                    },
                                    domProps: {
                                      value:
                                        _vm.deliveryData[project.id][city.id]
                                          .bill,
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.deliveryData[project.id][
                                          city.id
                                        ].updated = true
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.deliveryData[project.id][city.id],
                                          "bill",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.deliveryData[project.id][city.id]
                                            .bill_delivery,
                                        expression:
                                          "deliveryData[project.id][city.id].bill_delivery",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      p1laceholder: "Доставка",
                                    },
                                    domProps: {
                                      value:
                                        _vm.deliveryData[project.id][city.id]
                                          .bill_delivery,
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.deliveryData[project.id][
                                          city.id
                                        ].updated = true
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.deliveryData[project.id][city.id],
                                          "bill_delivery",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ])
                            : _vm._e()
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c(
              "vue-ladda",
              {
                attrs: {
                  "button-class": "btn btn-success",
                  "data-style": "zoom-in",
                  loading: _vm.loading,
                },
                on: { click: _vm.saveChanges },
              },
              [_vm._v("Сохранить\n        ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Ведомость цен на доставку")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }